<div class="modal-footer-bottom-row">
  <app-button
    *ngIf="showCancel"
    [style]="'secondary'"
    class="mr-2"
    (onClick)="onReject.emit()"
    [title]="rejectTitle"
    [ariaLabel]="rejectTitle + ' button'"
  ></app-button>
  <app-button
    *ngIf="showSave"
    [type]="useFormSubmit ? 'submit' : 'button'"
    [disabled]="isSubmitting || (useCustomDisabled ? disabled : (form?.invalid || false || disabled))"
    [title]="confirmTitle"
    [ariaLabel]="confirmTitle + ' button' + (isSubmitting ? ', submitting' : '')"
    (onClick)="onConfirmButtonClick()"
  ></app-button>
</div>
